import type { PortalCustomer } from "./Auth.typed";
import type { AuthModel } from "./AuthModel";

export class AuthAdapter {
  authModel: AuthModel;

  constructor(authModel: AuthModel) {
    this.authModel = authModel;
  }

  async loginPortal(customer: PortalCustomer, companyId?: string) {
    return await this.authModel.loginPortal(customer, companyId);
  }
}
